import React, { useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/b2b-portal/banner-portal.webp";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service healthcare_banner android_banner chatbot_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={10} lg={9} xl={8} xxl={8} className="my-auto">
            <div className="banenr_content">
              <h1 className="web_head_banner" style={{ marginBottom: "10px" }}>
                B2B Portal Development Services
              </h1>
              <span>
                Transform B2B Interactions with{" "}
                <span style={{ color: "#f47a14" }}>Scalable Digital</span>{" "}
                Platforms
              </span>
              <p style={{ marginTop: "10px" }}>
                B2B portal development enables businesses to establish an
                integrated platform for streamlined interactions with partners,
                suppliers, and buyers. TekRevol helps develop high-performance
                B2B portals for enhanced usability, security, and automation.
                Our portals feature advanced data management, real-time
                analytics, and scalable infrastructure. From custom APIs to ERP
                integration, we build custom solutions to fit your operational
                needs.
              </p>

              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Discuss Your Project
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
